

import templateProductReviewModal from '@/app-template/lib/components/ProductReviewModal.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProductReviewModal',
  components: { templateProductReviewModal },
});
